const FilterBar = ({ children, searchLabel = 'Search', searchPlaceholder = 'Search records', searchValue = '', onSearchChange, onClear, hasActiveFilters = false }) => (
  <div className="sa-filter-bar" aria-label="Resource filters">
    <label className="sa-search-field">
      <span className="visually-hidden">{searchLabel}</span>
      <input type="search" value={searchValue} placeholder={searchPlaceholder} onChange={(event) => onSearchChange?.(event.target.value)} />
    </label>
    <div className="sa-filter-bar__controls">{children}</div>
    {hasActiveFilters ? <button className="sa-tertiary-button" type="button" onClick={onClear}>Clear filters</button> : null}
  </div>
);

export default FilterBar;
